import type {
  IAPImageExtension,
  IAPResourceExtension,
  IResourceSettings,
  TS3BucketKey,
} from './types';

import { sanitizePathEdges } from '../string/path.util';
import { DEFAULT_SETTINGS } from './config';

export class APUtilResources {
  private static settings: IResourceSettings = DEFAULT_SETTINGS;

  static setSettings(settings: IResourceSettings) {
    this.settings = settings;
  }

  static resolveResourceUrl(resourceType: TS3BucketKey): string {
    if (!this.settings || !this.settings.base || !this.settings.paths[resourceType]) {
      throw new Error(`Resource settings not configured for type: ${resourceType}`);
    }
    const bucket = this.settings.base;
    const sanitizedBucket = sanitizePathEdges(bucket, 'end');
    const resourcePath = this.settings.paths[resourceType];
    const sanitizedPath = sanitizePathEdges(resourcePath, 'start');
    return `${sanitizedBucket}/${sanitizedPath}`;
  }

  /**
   * Build complete bucket image URL for flag types
   */
  static buildImageUrl = (
    bucketKey: TS3BucketKey,
    icon: string | undefined,
    extension: IAPImageExtension = 'svg',
    overrideSrc?: string
  ): string | undefined => {
    if (overrideSrc) {
      return overrideSrc;
    }

    if (!icon) {
      return undefined;
    }

    const bucket = this.resolveResourceUrl(bucketKey);

    if (!bucket) {
      return undefined;
    }

    return this.joinBucketPath(bucket, icon, extension);
  };

  /**
   * Utility function to build bucket image URLs
   */
  private static joinBucketPath = (
    bucket: string,
    icon: string,
    extension: IAPResourceExtension
  ): string => {
    const sanitizedBucket = sanitizePathEdges(bucket, 'end');
    const sanitizedIcon = sanitizePathEdges(icon, 'start');
    return `${sanitizedBucket}/${sanitizedIcon}.${extension}`;
  };
}

export default APUtilResources;
